<template>
  <v-row>
    <v-col cols="12">
      <h4 class="d-inline-block">
        {{ $vuetify.lang.t(`$vuetify.${weekday.i18n}`) }}
      </h4>
      <div v-show="weekday.original == 'Monday'" class="d-inline-block">
        <a
          style="color: #007CAD;"
          v-show="weekday.original == 'Monday'"
          class="ml-3"
          :title="
            $vuetify.lang.t(
              '$vuetify.EDIT_PLACE.RENTAL_SCHEDULE.COPY_MONDAY_SCHEDULE'
            )
          "
          @click="copyMondayToAll()"
        >
          <v-icon>mdi-content-copy</v-icon>
        </a>
      </div>
      <v-row>
        <v-col cols="8" class="py-0 pl-0">
          <v-row v-show="T2 > T1" class="col-12 pa-0 no-gutters">
            <v-col cols="12" class="row d-flex align-center">
              <div class="col-3 period-1 pa-6">
                {{ halfhoursToTime(T1) }} - {{ halfhoursToTime(T2) }}
              </div>
              <v-text-field
                v-model.number="spots12"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                :placeholder="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                outlined
                hide-details
                dense
                append-icon="mdi-account"
                class="col-2 mr-3"
              ></v-text-field>
              <v-text-field
                v-model.number="price12"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.HOURLY_RATE')
                "
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="min12"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MIN_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="max12"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MAX_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2"
                :suffix="currency"
                :disabled="disablePrices"
              />
            </v-col>
          </v-row>
          <v-row v-show="T3 > T2" class="col-12 pa-0 no-gutters">
            <v-col cols="12" class="row d-flex align-center">
              <div class="col-3 period-2 pa-6">
                {{ halfhoursToTime(T2) }} - {{ halfhoursToTime(T3) }}
              </div>
              <v-text-field
                v-model.number="spots23"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                :placeholder="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                outlined
                hide-details
                dense
                append-icon="mdi-account"
                class="col-2 mr-3"
              ></v-text-field>
              <v-text-field
                v-model.number="price23"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.HOURLY_RATE')
                "
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="min23"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MIN_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="max23"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MAX_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2"
                :suffix="currency"
                :disabled="disablePrices"
              />
            </v-col>
          </v-row>
          <v-row v-show="T1 > 0 || T3 < 48" class="pa-0 no-gutters">
            <v-col cols="12" class="row d-flex align-center">
              <div class="col-3 pa-6" translate>
                {{ $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.OTHER_TIMES') }}
              </div>
              <v-text-field
                v-model.number="spots31"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                :placeholder="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.NUMBER_OF_SPOTS')
                "
                type="number"
                outlined
                hide-details
                dense
                append-icon="mdi-account"
                class="col-2 mr-3"
              ></v-text-field>
              <v-text-field
                v-model.number="price31"
                :label="
                  $vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.HOURLY_RATE')
                "
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="min31"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MIN_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2 mr-3"
                :suffix="currency"
                :disabled="disablePrices"
              />

              <v-text-field
                v-model.number="max31"
                :label="$vuetify.lang.t('$vuetify.AVAILABILITY_TABLE.MAX_COST')"
                type="number"
                outlined
                hide-details
                dense
                class="col-2"
                :suffix="currency"
                :disabled="disablePrices"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" class="d-flex">
          <!-- <div tri-slider t1="t1" t2="t2" t3="t3"></div> -->
          <vue-slider
            v-model="sliderValue"
            :data="range(0, 48)"
            style="width: 100%;"
            :enable-cross="false"
            :marks="true"
            :min="0"
            :max="48"
          >
            <template v-slot:tooltip="{ value }">
              <div>{{ halfhoursToTime(value || 0) }}</div>
            </template>
            <template v-slot:mark="{ pos, value }">
              <span
                v-if="halfhoursToTime(value) == '00:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >00:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '03:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >03:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '06:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >06:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '09:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >09:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '12:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >12:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '15:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >15:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '18:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >18:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '21:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >21:00</span
              >
              <span
                v-if="halfhoursToTime(value) == '24:00'"
                class="custom-mark"
                :style="{ left: `${pos}%` }"
                >24:00</span
              >
            </template>
          </vue-slider>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable dot-notation */
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DayEditor',
  components: {
    VueSlider
  },
  props: {
    weekday: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    // Tells which object to change. Currently supported types are: whitelist, place
    useFor: {
      type: String,
      required: true
    },
    disablePrices: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      sliderValue: [this.T1, this.T2, this.T3],
      weekdays: [
        { i18n: 'MONDAY', original: 'Monday' },
        { i18n: 'TUESDAY', original: 'Tuesday' },
        { i18n: 'WEDNESDAY', original: 'Wednesday' },
        { i18n: 'THURSDAY', original: 'Thursday' },
        { i18n: 'FRIDAY', original: 'Friday' },
        { i18n: 'SATURDAY', original: 'Saturday' },
        { i18n: 'SUNDAY', original: 'Sunday' }
      ]
    }
  },
  computed: {
    ...mapGetters('whitelists', ['whitelist']),
    ...mapGetters('places', ['place']),
    T1: {
      get() {
        return (
          this[this.useFor].AvailabilityTable[`${this.weekday.original}T1`] || 0
        )
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}T1`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}T1`,
            value
          })
        }
      }
    },
    T2: {
      get() {
        return (
          this[this.useFor].AvailabilityTable[`${this.weekday.original}T2`] || 0
        )
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}T2`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}T2`,
            value
          })
        }
      }
    },
    T3: {
      get() {
        return (
          this[this.useFor].AvailabilityTable[`${this.weekday.original}T3`] || 0
        )
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}T3`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}T3`,
            value
          })
        }
      }
    },
    spots12: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}12Spots`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}12Spots`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}12Spots`,
            value
          })
        }
      }
    },
    spots23: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}23Spots`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}23Spots`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}23Spots`,
            value
          })
        }
      }
    },
    spots31: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}31Spots`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}31Spots`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}31Spots`,
            value
          })
        }
      }
    },
    price12: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}12Price`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}12Price`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}12Price`,
            value
          })
        }
      }
    },
    price23: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}23Price`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}23Price`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}23Price`,
            value
          })
        }
      }
    },
    price31: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}31Price`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}31Price`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}31Price`,
            value
          })
        }
      }
    },
    min12: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}12MinCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}12MinCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}12MinCost`,
            value
          })
        }
      }
    },
    min23: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}23MinCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}23MinCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}23MinCost`,
            value
          })
        }
      }
    },
    min31: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}31MinCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}31MinCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}31MinCost`,
            value
          })
        }
      }
    },
    max12: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}12MaxCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}12MaxCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}12MaxCost`,
            value
          })
        }
      }
    },
    max23: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}23MaxCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}23MaxCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}23MaxCost`,
            value
          })
        }
      }
    },
    max31: {
      get() {
        return this[this.useFor].AvailabilityTable[
          `${this.weekday.original}31MaxCost`
        ]
      },
      set(value) {
        if (this.useFor === 'whitelist') {
          this.setWhitelistAvailabilityTableValue({
            key: `${this.weekday.original}31MaxCost`,
            value
          })
        }
        if (this.useFor === 'place') {
          this.setPlaceAvailabilityTableValue({
            key: `${this.weekday.original}31MaxCost`,
            value
          })
        }
      }
    }
  },
  watch: {
    sliderValue(newValue) {
      // eslint-disable-next-line prefer-destructuring
      this.T1 = newValue[0]
      // eslint-disable-next-line prefer-destructuring
      this.T2 = newValue[1]
      // eslint-disable-next-line prefer-destructuring
      this.T3 = newValue[2]
    },
    // If some of time values changes(changed in copyMondayToAll) apply those new values for sliderValue
    T1(newValue) {
      this.sliderValue = [newValue, this.T2, this.T3]
    },
    T2(newValue) {
      this.sliderValue = [this.T1, newValue, this.T3]
    },
    T3(newValue) {
      this.sliderValue = [this.T1, this.T2, newValue]
    }
  },
  created() {
    this.sliderValue = [this.T1, this.T2, this.T3]
  },
  methods: {
    ...mapMutations('whitelists', ['setWhitelistAvailabilityTableValue']),
    ...mapMutations('places', ['setPlaceAvailabilityTableValue']),
    // Returns formatted time value
    halfhoursToTime(hh) {
      const h = Math.floor(hh / 2)
        .toString()
        .padStart(2, '0')
      const m = ((hh % 2) * 30).toString().padStart(2, '0')
      return `${h}:${m}`
    },
    // Returns array of numbers, eg. with input(1,12) [1,2,3,...,12]
    range(from, to) {
      const list = []
      for (let i = from; i <= to; i += 1) {
        list.push(i)
      }
      return list
    },
    // Sets every day(mon to sun) values to be as monday
    copyMondayToAll() {
      for (let i = 0; i < this.weekdays.length; i += 1) {
        const weekday = this.weekdays[i]

        if (weekday.original !== 'Monday') {
          if (this.useFor === 'whitelist') {
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}T1`,
              value: this[this.useFor].AvailabilityTable.MondayT1
            })
            this.T1 = this[this.useFor].AvailabilityTable.MondayT1
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}T2`,
              value: this[this.useFor].AvailabilityTable.MondayT2
            })
            this.T2 = this[this.useFor].AvailabilityTable.MondayT2
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}T3`,
              value: this[this.useFor].AvailabilityTable.MondayT3
            })
            this.T3 = this[this.useFor].AvailabilityTable.MondayT3

            this.sliderValue = [
              this.whitelist.AvailabilityTable.MondayT1,
              this.whitelist.AvailabilityTable.MondayT2,
              this.whitelist.AvailabilityTable.MondayT3
            ]

            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}12Price`,
              value: this[this.useFor].AvailabilityTable.Monday12Price
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}23Price`,
              value: this[this.useFor].AvailabilityTable.Monday23Price
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}31Price`,
              value: this[this.useFor].AvailabilityTable.Monday31Price
            })

            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}12MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday12MinCost
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}23MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday23MinCost
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}31MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday31MinCost
            })

            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}12MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday12MaxCost
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}23MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday23MaxCost
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}31MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday31MaxCost
            })

            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}12Spots`,
              value: this[this.useFor].AvailabilityTable.Monday12Spots
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}23Spots`,
              value: this[this.useFor].AvailabilityTable.Monday23Spots
            })
            this.setWhitelistAvailabilityTableValue({
              key: `${weekday.original}31Spots`,
              value: this[this.useFor].AvailabilityTable.Monday31Spots
            })
          }
          if (this.useFor === 'place') {
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}T1`,
              value: this[this.useFor].AvailabilityTable.MondayT1
            })
            this.T1 = this[this.useFor].AvailabilityTable.MondayT1
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}T2`,
              value: this[this.useFor].AvailabilityTable.MondayT2
            })
            this.T2 = this[this.useFor].AvailabilityTable.MondayT2
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}T3`,
              value: this[this.useFor].AvailabilityTable.MondayT3
            })
            this.T3 = this[this.useFor].AvailabilityTable.MondayT3

            this.sliderValue = [
              this.place.AvailabilityTable.MondayT1,
              this.place.AvailabilityTable.MondayT2,
              this.place.AvailabilityTable.MondayT3
            ]

            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}12Price`,
              value: this[this.useFor].AvailabilityTable.Monday12Price
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}23Price`,
              value: this[this.useFor].AvailabilityTable.Monday23Price
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}31Price`,
              value: this[this.useFor].AvailabilityTable.Monday31Price
            })

            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}12MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday12MinCost
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}23MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday23MinCost
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}31MinCost`,
              value: this[this.useFor].AvailabilityTable.Monday31MinCost
            })

            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}12MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday12MaxCost
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}23MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday23MaxCost
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}31MaxCost`,
              value: this[this.useFor].AvailabilityTable.Monday31MaxCost
            })

            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}12Spots`,
              value: this[this.useFor].AvailabilityTable.Monday12Spots
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}23Spots`,
              value: this[this.useFor].AvailabilityTable.Monday23Spots
            })
            this.setPlaceAvailabilityTableValue({
              key: `${weekday.original}31Spots`,
              value: this[this.useFor].AvailabilityTable.Monday31Spots
            })
          }
        }
      }
    }
  }
}
</script>
<style>
.vue-slider-rail {
  background: #293142;
}
.vue-slider-dot-handle {
  background-color: #FFC41F;
}
.vue-slider-dot-tooltip-inner {
  background-color: #FFC41F;
}
.vue-slider-dot-tooltip-text {
  color: #293142;
}
.vue-slider-process {
  background-color: #FFC41F;
}
.custom-mark {
  position: absolute;
  top: 10px;
  transform: translateX(-50%);
  white-space: nowrap;
  color: grey;
}
</style>
